import React from 'react';
import Header from '../components/layout/header';
import Secone from '../components/layout/section1';
import './home.css'
import Sec2 from '../components/layout/section2';
import Footer from '../components/layout/footer';
import Sec3 from '../components/layout/section3';
import Sec4 from '../components/layout/section4';
const Home = () => {
    return ( <>
<body className='bodyyy'>
    <main>
    <Header />
<Secone />

<Sec3 />
<Sec2 />

<Sec4 />
<Footer />
    </main>
</body>
    </> );
}
 
export default Home;